/**
 * Generate a unique crawler name based on existing crawler names
 *
 * @param existingNames - Array of existing crawler names
 * @param baseName - Base name to use (defaults to "New Crawler")
 * @returns A unique crawler name
 */
export const generateUniqueCrawlerName = (
  existingNames: string[],
  baseName: string = 'New Crawler'
): string => {
  // If base name doesn't exist, return it
  if (!existingNames.includes(baseName)) {
    return baseName;
  }

  // Find unique name by appending number
  let counter = 2;
  let uniqueName = `${baseName} ${counter}`;

  while (existingNames.includes(uniqueName)) {
    counter++;
    uniqueName = `${baseName} ${counter}`;
  }

  return uniqueName;
};
